import axios from "axios";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { url } from "../link";
const Updatecoursecat = () => {
  var rx = 0;
  const { state } = useLocation();
  const [id, setid] = useState(state[rx++]);
  const [name, setname] = useState(state[rx++]);
  const [price, setprice] = useState(state[rx++]);
  const [duration, setduration] = useState(state[rx++]);
  const [coursetitle, setcoursetitle] = useState(state[rx++]);
  const submitdata = () => {
    const value = {
      id: id,
      name: name,
      price: price,
      duration: duration,
      coursetitle: coursetitle,
    };
    axios.post(url + "/edusphere/updatecoursecat", value);
    setid("");
    setname("");
    setprice("");
    setduration("");
    setcoursetitle("");
  };
  return (
    <div>
      <h1>Add coursecat</h1>
      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setid(e.target.value)}
          value={id}
          placeholder="Enter id"
        />
        <label htmlFor="id">id</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setname(e.target.value)}
          value={name}
          placeholder="Enter name"
        />
        <label htmlFor="name">name</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setprice(e.target.value)}
          value={price}
          placeholder="Enter price"
        />
        <label htmlFor="price">price</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setduration(e.target.value)}
          value={duration}
          placeholder="Enter duration"
        />
        <label htmlFor="duration">duration</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setcoursetitle(e.target.value)}
          value={coursetitle}
          placeholder="Enter coursetitle"
        />
        <label htmlFor="coursetitle">coursetitle</label>
      </div>

      <input
        type="submit"
        className="btn btn-primary"
        onClick={submitdata}
        style={{ width: "100%" }}
      />
    </div>
  );
};
export default Updatecoursecat;
